import "./OfferPopup.css";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../config";
import { useEffect, useState } from "react";

const AUTO_CLOSE_TIME = window.innerWidth < 768 ? 12000 : 8000;

const OfferPopup = ({ offer, onClose }) => {
  const navigate = useNavigate();
  const [timeLeft, setTimeLeft] = useState("");

  /* ---------------- COUNTDOWN TIMER ---------------- */
  useEffect(() => {
    if (!offer?.endDate) return;

    const updateTimer = () => {
      const now = Date.now();
      const end = new Date(offer.endDate).getTime();
      const diff = end - now;

      if (diff <= 0) {
        setTimeLeft("Offer Expired");
        return;
      }

      const d = Math.floor(diff / (1000 * 60 * 60 * 24));
      const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const m = Math.floor((diff / (1000 * 60)) % 60);

      setTimeLeft(`${d}d ${h}h ${m}m left`);
    };

    updateTimer(); // run immediately

    const interval = setInterval(updateTimer, 60000); // update every minute

    return () => clearInterval(interval);
  }, [offer]);

  /* ---------------- AUTO CLOSE ---------------- */
  useEffect(() => {
    if (!offer) return;

    const timer = setTimeout(() => {
      onClose();
    }, AUTO_CLOSE_TIME);

    return () => clearTimeout(timer);
  }, [offer, onClose]);

  if (!offer) return null;

  return (
    <div
      className="offer-popup-backdrop"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div className="offer-popup-glass" onClick={(e) => e.stopPropagation()}>
        <div className="offer-popup-header">
          <button
            className="offer-close"
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
          >
            ×
          </button>
        </div>

        <div className="scan-line" />

        <div className="offer-image-wrap">
          <img
            src={`${API_BASE_URL}${offer.image}`}
            alt={offer.title}
            loading="lazy"
          />
        </div>

        <div className="offer-content">
          <span className="offer-chip">🚀 LIMITED OFFER</span>

          <h3>{offer.title}</h3>
          <p>{offer.subtitle}</p>

          <div className="offer-timer">{timeLeft}</div>

          <button className="offer-cta" onClick={() => navigate("/course")}>
            Claim Offer →
          </button>
        </div>
      </div>
    </div>
  );
};

export default OfferPopup;
